import http from "helpers/http.js";

const API_URL = process.env.REACT_APP_API_URL;

const createPaymentIntent = async (products, promotionCode, email, firstName, currencyCode, countryCode, source = null, rewardsCouponId = null) => {
    return await http.post(API_URL + "api/payments/create-intent", {
        items: products,
        promotionCode,
        email,
        firstName,
        currencyCode,
        countryCode,
        source,
        rewardsCouponId
    });
};

const verifyAndGenerateActivationCode = async (paymentIntentId, AutoRedeemUsername = null) => {
    return await http.post(API_URL + "api/payments/verify-and-generate", {
        paymentIntentId,
        AutoRedeemUsername
    });
}

const getPaymentKeys = async (paymentIntentId, AutoRedeemUsername = null) => {
    return await http.post(API_URL + "api/payments/get-payment-keys", {
        paymentIntentId,
        AutoRedeemUsername
    });
}

const checkPromotionCode = async (promotionCode, productIds) => {
    return await http.post(API_URL + "api/payments/check-promotion-code", {
        promotionCode,
        productIds,
    });
}

const getPricing = async () => {
    return await http.get(API_URL + "api/payments/get-price");
}


const getIP = async () => {
    return await http.get(API_URL + "api/payments/get-ip");
}

const getCountryCode = async () => {
    return await http.get(API_URL + "api/payments/get-country-code");
}

const updatePaymentIntentEmail = async (paymentIntentId, email) => {
    return await http.post(API_URL + "api/payments/update-email", {
        paymentIntentId,
        email
    });
}

export default {
    createPaymentIntent,
    verifyAndGenerateActivationCode,
    getPaymentKeys,
    checkPromotionCode,
    getPricing,
    getIP,
    getCountryCode,
    updatePaymentIntentEmail,
};